var themeOptions = function () { return ({
    components: {
        MuiMenuItem: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=menuTheme.js.map